/**
 * 전역 오류 핸들러 (BOOTH-97) — 어디서도 잡지 않은 예외·거절을 활동 이벤트로 남긴다.
 * `main.tsx` 가 렌더 전에 한 번 부른다. 중복 등록은 모듈 플래그로 막는다(StrictMode·HMR).
 */
import { trackError } from "./activity";

let installed = false;

export function installGlobalErrorHandlers(): void {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("error", (event) => {
    // Error 객체가 없으면(크로스 오리진 스크립트 등) 메시지 문자열만 남는다
    trackError("unhandled_error", event.error ?? event.message);
  });
  window.addEventListener("unhandledrejection", (event) => {
    trackError("unhandled_rejection", event.reason);
  });
}
